import { Product } from 'components/analytics/product/Product'
import { useLocation, useSearchParams } from 'react-router-dom'
import { downloadFile, getAllQueryParams, setQueryParams } from 'utils/utils'
import { INITIAL_DATA_FILTER, INITIAL_ADVANCE_FILTER } from 'configs/analytics/configTableProduct'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_PRODUCT } from 'services/apiAnalyticProduct'
import { Alert } from 'avo-ui'

export const ProductContainer = () => {
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER
    const [queryFilter, setQueryFilter] = useState(INITIAL_ADVANCE_FILTER)
    const [queryList, setQueryList] = useState({})
    const { fetching: getProductGraph, data: productGraph, isLoading: isLoadingGraph } = useFetch(API_PRODUCT.GRAPH)
    const { fetching: getProductList, data: productList, isLoading: isLoadingList } = useFetch(API_PRODUCT.LIST)
    const { fetching: exportProductList, isLoading: isLoadingExport } = useFetch(API_PRODUCT.EXPORT)
    const {
        fetching: getProductComparison,
        data: productComparison,
        isLoading: isLoadingComparison,
    } = useFetch(API_PRODUCT.COMPARISON)
    const [modal, setModal] = useState({
        filter: false,
        export: false,
    })

    const getQuery = () => {
        const currentQuery = { ...query }
        const newQueryFilter = { ...INITIAL_ADVANCE_FILTER }
        Object.entries(currentQuery).forEach(([key, item]) => {
            if (key === 'brand_ids') {
                const splitObject = item?.split('|')
                const parseObject = splitObject?.map((i) => JSON.parse(i))
                newQueryFilter[key] = parseObject
                currentQuery[key] = parseObject?.map((i) => i?.value)
            }
        })

        return { currentQuery, newQueryFilter }
    }

    useEffect(() => {
        const { page, limit, order_by, order_type, search, ...queryRest } = getQuery()?.currentQuery
        getProductGraph(queryRest)
        getProductComparison(queryRest)
    }, [query?.start_date, query?.end_date, query?.brand_ids])

    useEffect(() => {
        const { currentQuery, newQueryFilter } = getQuery()
        setQueryFilter({ ...queryFilter, ...newQueryFilter })
        setQueryList(currentQuery)
        getProductList({ ...currentQuery })
    }, [location?.search])

    const onChangeQuery = (queryParams) => {
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const setShowModal = (item) => {
        setModal({ ...modal, ...item })
    }

    const onFilter = (filter) => {
        const queryFilter = getQueryAdvanceFilter(filter)
        onChangeQuery({
            ...queryFilter,
            page: 1,
            search: '',
            limit: 20,
            order_by: 'total_product_sold',
            order_type: 'desc',
        })
        setShowModal({ filter: false })
    }

    const getQueryAdvanceFilter = (filter) => {
        const queryFilter = { ...filter }
        Object.entries(queryFilter).forEach(([key, item]) => {
            const mapData = item.map((i) => JSON.stringify(i))
            queryFilter[key] = mapData.join('|')
        })
        return queryFilter
    }

    const onSelectSort = (value) => {
        const splitSort = value?.split('-')
        onChangeQuery({ order_by: splitSort[0], order_type: splitSort[1] })
    }

    const onExport = () => {
        const { page, limit, ...queryRest } = queryList
        exportProductList(queryRest, '', {}, 'blob').then((response) => {
            downloadFile(
                null,
                response,
                `Analytic-Product-Export-Start_${query?.start_date}-End_${query?.end_date}.xlsx`,
            )
            setShowModal({ export: false })
            return Alert({
                icon: 'success',
                title: 'Success',
                message: 'Analytic Product Exported',
            })
        })
    }

    const props = {
        dataComparison: productComparison?.data,
        dataGraph: productGraph?.data,
        dataList: productList?.data,
        query,
        onChangeQuery,
        queryFilter,
        onFilter,
        modal,
        setShowModal,
        onSelectSort,
        isLoadingComparison,
        isLoadingGraph,
        isLoadingList,
        isLoadingExport,
        onExport,
    }

    return <Product {...props} />
}
